import moment from 'moment';

export const formatTime = (time?: string): string => {
  if (!time) {
    return '';
  }
  return moment(time).format('MM/DD/YYYY hh:mm:ss');
};

export const wait = (time = 0): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
};
